import { Popover, SxProps, Theme } from '@mui/material';

import { appColors } from '../assets/appColors';

/** The path for this SVG was pulled from Figma */
const RoundedTriangle = () => (
  <svg
    width="22"
    height="25"
    viewBox="0 0 22 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={SVGTriangleStyle}
  >
    <path
      d="M1.75 10.3349C0.0833308 11.2972 0.0833333 13.7028 1.75 14.6651L17.5 23.7583C19.1667 24.7206 21.25 23.5178 21.25 21.5933L21.25 3.40673C21.25 1.48223 19.1667 0.279418 17.5 1.24167L1.75 10.3349Z"
      fill="black"
      stroke="black"
    />
  </svg>
);

type BackrsPopoverProps = Readonly<{
  anchorId: string;
  isPopoverOpen: boolean;
  setIsPopoverOpen: (value: boolean) => void;
  children: React.ReactNode;
}>;

export const BackrsPopover = ({
  anchorId,
  isPopoverOpen,
  setIsPopoverOpen,
  children,
}: BackrsPopoverProps) => {
  return (
    <Popover
      open={isPopoverOpen}
      anchorEl={document.getElementById(anchorId)}
      onClose={() => setIsPopoverOpen(false)}
      transformOrigin={{ vertical: 'center', horizontal: 'right' }}
      onClick={() => setIsPopoverOpen(false)}
      PaperProps={{
        sx: paperSx,
      }}
    >
      <>
        <RoundedTriangle />
        {children}
      </>
    </Popover>
  );
};

const paperSx: SxProps<Theme> = {
  fontSize: '12pt',
  padding: 2,
  maxWidth: '300px',
  backgroundColor: appColors.neutral.black,
  color: appColors.neutral.white,
  borderRadius: 4,
  whiteSpace: 'pre-wrap',
  overflow: 'visible',
  marginLeft: '-20px',
} as const;

const SVGTriangleStyle: React.CSSProperties = {
  position: 'absolute',
  top: 'calc(50% - 12px)',
  right: '-16px',
  transform: 'rotate(180deg)',
} as const;
